import React from 'react';
import { round } from 'lodash';
import { styled } from '@mui/material';

import { Avatar, Box, Stack, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const WorkloadAnalyticsPopover = ({ student }) => {
    return (
        <CustomBox>
            <Stack alignItems={'center'} direction={'row'} spacing={2}>
                <Avatar size={'small'} user={student} />
                <Stack sx={{ minWidth: 0 }}>
                    <Text color={'light'} noWrap variant={'p3'}>
                        {getUserPreferredFullName(student)}
                    </Text>
                    <Text variant={'p3'}>
                        {student.totalPoints} Points ({round(student.contributionPercentage)}%)
                    </Text>
                </Stack>
            </Stack>
        </CustomBox>
    );
};

const CustomBox = styled(Box)(({ theme }) => {
    return {
        position: 'relative',
        zIndex: theme.zIndex.tooltip,
        borderRadius: '12px',
        width: '9.125rem',
        padding: theme.spacing(2),
        background: theme.palette.ensightful.shades[0],
        boxShadow: theme.palette.ensightful.shadows[1],
    };
});

export default WorkloadAnalyticsPopover;
